import {Component, HostListener, OnInit} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {PassOnLogService} from '../../../services/pass-on-log.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'pass-on-log-status-history',
    templateUrl: './pass-on-log-status-history.component.html',
    styleUrls: ['./pass-on-log-status-history.component.scss']
})
export class PassOnLogStatusHistoryComponent implements OnInit {
    showModal = false;
    activities = [];

    constructor(
        public api: ApiClientService,
        public passOnLogService: PassOnLogService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.activities = this.passOnLogService.passOnLogInHistoryModal.readers;
    }

    hideModal() {
        this.passOnLogService.isPassOnLogStatusHistoryModalShow = false;
        this.passOnLogService.passOnLogInHistoryModal = null;
        this.urlService.modalClosed.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-status-history/pass-on-log-status-history.component.ts